import {
  Flame,
  Wind,
  Droplets,
  Volume2,
  Wrench,
  Leaf,
  Recycle,
  ShieldCheck,
} from "lucide-react";
import { SectionHeading } from "./ProductSelector";

const ITEMS = [
  {
    icon: Flame,
    title: "Klasa A1 — niepalna",
    text: "Materiał całkowicie niepalny. Maksymalne bezpieczeństwo pożarowe budynku.",
  },
  {
    icon: Wind,
    title: "Paroprzepuszczalna",
    text: "Przegroda oddycha. Brak ryzyka kondensacji wilgoci wewnątrz konstrukcji.",
  },
  {
    icon: Droplets,
    title: "Hydrofobizowana",
    text: "Odporna na wilgoć. Zachowuje parametry termiczne także w trudnych warunkach.",
  },
  {
    icon: Volume2,
    title: "Tłumienie hałasu",
    text: "Doskonała izolacja akustyczna — komfort akustyczny pomieszczeń.",
  },
  {
    icon: Wrench,
    title: "Łatwy montaż",
    text: "Elastyczna i sprężysta — łatwo dopasowuje się do nierównych powierzchni.",
  },
  {
    icon: ShieldCheck,
    title: "Certyfikat EUCEB",
    text: "Potwierdzona biorozpuszczalność włókien. Bezpieczeństwo dla zdrowia.",
  },
  {
    icon: Recycle,
    title: "Sprężona w rolce",
    text: "Oszczędność w transporcie i składowaniu. Po rozwinięciu wraca do pełnej grubości.",
  },
  {
    icon: Leaf,
    title: "Trwałość",
    text: "Odporność na starzenie. Stabilne parametry przez cały okres eksploatacji.",
  },
];

export default function Advantages() {
  return (
    <section
      data-testid="advantages-section"
      className="bg-white py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="04 · Zalety"
          title="Dlaczego BUDOBET.PL?"
          subtitle="Osiem powodów, dla których profesjonaliści wybierają naszą wełnę mineralną szklaną."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 border-2 border-black">
          {ITEMS.map((item, idx) => (
            <div
              key={item.title}
              data-testid={`advantage-${idx}`}
              className={`p-7 lg:p-8 bg-white hover:bg-red-50 transition group relative ${
                idx % 4 !== 3 ? "lg:border-r-2 border-black" : ""
              } ${idx % 2 !== 1 ? "sm:border-r-2 lg:border-r-0" : ""} ${
                idx < ITEMS.length - 1 ? "border-b-2 border-black" : ""
              } ${idx % 4 === 3 ? "lg:border-r-0" : ""}`}
            >
              {/* Number */}
              <span className="font-display text-xs text-zinc-400 absolute top-3 right-4">
                0{idx + 1}
              </span>
              <div className="h-14 w-14 border-2 border-black flex items-center justify-center mb-5 group-hover:bg-red-600 group-hover:border-red-600 transition">
                <item.icon
                  className="h-7 w-7 text-black group-hover:text-white transition"
                  strokeWidth={1.8}
                />
              </div>
              <h3 className="font-display text-xl tracking-tight text-zinc-900 mb-2 uppercase leading-tight">
                {item.title}
              </h3>
              <p className="text-sm text-zinc-600 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
